<!-- TODO: need to refacto with a ng-container instead of ion-list -->
<ion-list
  *ngIf="question.display"
  [ngSwitch]="question.controlType"
  [formGroup]="formGroup"
>
  <bepatient-input-image-v3
    *ngSwitchCase="questionControlTypes.IMAGE"
    [question]="question"
    [color]="color"
  >
  </bepatient-input-image-v3>

  <bepatient-input-semantic-v3
    *ngSwitchCase="questionControlTypes.SEMANTIC"
    [color]="color"
    [question]="question"
  >
  </bepatient-input-semantic-v3>

  <bepatient-input-description-v3
    *ngSwitchCase="questionControlTypes.DESCRIPTION"
    [color]="color"
    [question]="question"
  >
  </bepatient-input-description-v3>

  <bepatient-input-social-security-v3
    *ngSwitchCase="questionControlTypes.SOCIAL_SECURITY"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-input-social-security-v3>

  <bepatient-input-text-v3
    *ngSwitchCase="questionControlTypes.TEXT"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-input-text-v3>

  <bepatient-input-dropdown-v3
    *ngSwitchCase="questionControlTypes.DROPDOWN"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-input-dropdown-v3>

  <bepatient-input-multi-dropdown-v3
    *ngSwitchCase="questionControlTypes.MULTI_DROPDOWN"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-input-multi-dropdown-v3>

  <bepatient-input-number-range-v3
    *ngSwitchCase="questionControlTypes.NUMBER_RANGE"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
    [isLoadingForm]="isLoadingForm"
  >
  </bepatient-input-number-range-v3>

  <bepatient-input-range-v3
    *ngSwitchCase="questionControlTypes.RANGE"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-input-range-v3>

  <bepatient-input-toggle-v3
    *ngSwitchCase="questionControlTypes.TOGGLE"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-input-toggle-v3>

  <bepatient-input-checkbox-v3
    *ngSwitchCase="questionControlTypes.CHECKBOX"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-input-checkbox-v3>

  <bepatient-input-radio-v3
    *ngSwitchCase="questionControlTypes.RADIO"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-input-radio-v3>

  <bepatient-input-datetime-v3
    *ngSwitchCase="questionControlTypes.DATETIME"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-input-datetime-v3>

  <bepatient-input-textarea-v3
    *ngSwitchCase="questionControlTypes.TEXTAREA"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-input-textarea-v3>

  <bepatient-field-nested-group-v3
    *ngSwitchCase="questionControlTypes.NESTED_GROUP"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  >
  </bepatient-field-nested-group-v3>

  <bepatient-eq5-slider-v3
    *ngSwitchCase="questionControlTypes.EQ5"
    [question]="question"
    [formGroup]="formGroup"
    [color]="color"
  ></bepatient-eq5-slider-v3>

  <bepatient-input-html-v3
    *ngSwitchCase="questionControlTypes.HTML"
    [question]="question"
  >
  </bepatient-input-html-v3>

  <bepatient-input-photo-v3
    *ngSwitchCase="questionControlTypes.PHOTO"
    [formGroup]="formGroup"
    [question]="question"
    [readonly]="readonly"
  ></bepatient-input-photo-v3>

  <bepatient-fields-block-v3
    *ngSwitchCase="questionControlTypes.FIELDS_BLOC"
    [question]="question"
    [formGroup]="formGroup"
    [readonly]="readonly"
    [color]="color"
  >
  </bepatient-fields-block-v3>

  <bepatient-input-file-v3
    *ngSwitchCase="questionControlTypes.FILE"
    [formGroup]="formGroup"
    [question]="question"
    [color]="color"
  ></bepatient-input-file-v3>

  <bepatient-input-hidden-v3
    *ngSwitchCase="questionControlTypes.HIDDEN"
    [hidden]="question.type"
  ></bepatient-input-hidden-v3>

  <bepatient-input-signature-pad-v3
    *ngSwitchCase="questionControlTypes.SIGNATURE_PAD"
    [formGroup]="formGroup"
    [question]="question"
    [color]="color"
  >
  </bepatient-input-signature-pad-v3>
  <bepatient-input-video-v3
    *ngSwitchCase="questionControlTypes.VIDEO"
    [formGroup]="formGroup"
    [question]="question"
    [color]="color"
  >
  </bepatient-input-video-v3>
  <bepatient-input-button-v3
    *ngSwitchCase="questionControlTypes.BUTTON"
    [formGroup]="formGroup"
    [question]="question"
    [color]="color"
  >
  </bepatient-input-button-v3>
  <bepatient-input-time-v3
    *ngSwitchCase="questionControlTypes.TIME"
    [formGroup]="formGroup"
    [question]="question"
    [color]="color"
  >
  </bepatient-input-time-v3>
</ion-list>
